
import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import ProjectDocument from 'src/entities/ProjectDocument';
import ProjectDocumentMiniatureComponent from './ProjectDocumentMiniature.component';
import {
  GetDocumentImageAction,
  getDocumentImage
} from 'src/actions/project/get-document-image/GetDocumentImage.actions';
import { 
  downloadDocument, 
  DownloadDocumentAction 
} from 'src/actions/project/download-document/DownloadDocument.actions';

interface StateProps {
  image?: File;
}

interface OwnProps {
  projectDocument: ProjectDocument;
}

interface DispatchProps {
  getDocumentImage: (documentId: number, imageUrl: string) => Promise<GetDocumentImageAction>;
  download: (document: string, id: number, download: boolean) => Promise<DownloadDocumentAction>;
}

interface Props extends StateProps, OwnProps, DispatchProps {
}

class ProjectDocumentMiniatureContainer extends React.Component<Props> {

  public componentDidMount(): void {
    this.props.getDocumentImage(this.props.projectDocument.id, this.props.projectDocument.imageUrl);
  }

  public render(): React.ReactNode {
    if (!this.props.image) {
      return null;
    }

    return (
      <ProjectDocumentMiniatureComponent
        projectDocument={this.props.projectDocument}
        image={this.props.image}
        download={() => this.props.download(this.props.projectDocument.url, this.props.projectDocument.id, false)}
      />
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    getDocumentImage: (documentId: number, imageUrl: string): Promise<GetDocumentImageAction> => {
      return dispatch(getDocumentImage(documentId, imageUrl));
    },
    download: (document: string, id: number, download: boolean): Promise<DownloadDocumentAction> => {
      return dispatch(downloadDocument(document, id, download));
    }
  };
};

const mapStateToProps: (state: RootState, ownProps: OwnProps) => StateProps = (state: RootState, ownProps: OwnProps):
  StateProps => ({
    image: state.getDocumentImage.images[ownProps.projectDocument.id]
  });

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDocumentMiniatureContainer);


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-documents/ProjectDocumentMiniature.container.tsx